export const benefits = [
  {
    title: '11years',
    text: '11yearsDescription',
  },
  {
    title: '3',
    text: '3description',
  },
  {
    title: '5M',
    text: '5MDescription',
  },
  {
    title: '0%',
    text: '0percentDescription',
  },
  {
    title: '360°',
    text: '360Description',
  },
];

export const villaLandingBenefits = [
  {
    title: '11years',
    text: '11yearsDescription',
  },
  {
    title: '0%',
    text: '0percentDescription',
  },
  {
    title: '5M',
    text: '5MDescription',
  },
  {
    title: '360°',
    text: '360Description',
  },
];

export const apartmentsLandingBenefits = [
  {
    title: '11years',
    text: '11yearsDescription',
  },
  {
    title: '146',
    text: '146DescriptionLanding',
  },
  {
    title: '5M',
    text: '5MDescription',
  },

  {
    title: '360°',
    text: '360Description',
  },
  {
    title: '0%',
    text: '0percentDescription',
  },
];

export const propertymanagement = [
  {
    title: '14years',
    text: '12yearsDescription',
  },
  {
    title: '140',
    text: '60Description',
  },
  {
    title: '69%',
    text: '69percentDescription',
  },

  {
    title: '482',
    text: '48Description',
  },
  {
    title: '98%',
    text: '98percentDescription',
  },
];

export const rentLanding = [
  {
    title: '11yearslong',
    text: '11yearsRentDescription',
  },
  {
    title: '1350',
    text: '1350Description',
  },
  {
    title: '92%',
    text: '92percentDescription',
  },
];
